import {Component, Input, OnInit} from '@angular/core';
import {PaymentRequestReminderSummaryModel} from "../../entity/paymentRequestReminderSummary.model";
import {PaymentRequestReminderModel} from "../../entity/paymentRequestReminder.model";

@Component({
    selector: 'app-payment-request-reminder-item',
    templateUrl: './payment-request-reminder-item.component.html',
})
export class PaymentRequestReminderItemComponent implements OnInit {

    @Input() entity: PaymentRequestReminderSummaryModel | PaymentRequestReminderModel;

    constructor() {
    }

    ngOnInit() {
    }

}
